import type { FormInstance } from '@arco-design/web-react/es/Form';

import { SKU_RESOURCE_MODULES_FIELD, type SkuResourceModulesState } from '../types';

/**
 * 取消指定模块勾选。
 * 仅当 skuResourceModules 已存在该 key 时写入，避免给尚未声明该模块的交付类型凭空加 key。
 */
export function disableSkuModulesForPreset(form: FormInstance, moduleKeys: readonly string[]): void {
  if (!moduleKeys.length) return;
  const current = form.getFieldValue?.(SKU_RESOURCE_MODULES_FIELD) as SkuResourceModulesState | undefined;
  if (!current || typeof current !== 'object') return;

  const next = { ...current };
  let changed = false;
  for (const key of moduleKeys) {
    if (key in next && next[key] !== false) {
      next[key] = false;
      changed = true;
    }
  }
  if (changed) {
    form.setFieldValue(SKU_RESOURCE_MODULES_FIELD, next);
  }
}
